import React from 'react';
export default () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '70vh' }}>
            <img src="/img/others/img-20.png" alt="" width='30%' />
        </div>
    )
}